import { useEffect, useRef } from 'react';
import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';
import { useUiChangeKindSignal } from '@/lib/uiChangeBus';

export interface BundleListItem {
  bundle_id: string;
  title: string;
  description: string | null;
  created_at: string;
  created_by: number;
  created_by_name: string | null;
  updated_at: string | null;
  updated_by: number | null;
  updated_by_name: string | null;
  volume_count: number;
  section_count: number;
  group_count: number;
  file_count: number;
}

const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

export const useBundles = (matterGuid: string | undefined) => {
  const { data, error, isLoading, mutate } = useSWR<BundleListItem[]>(
    matterGuid ? `/bundle/matter/${matterGuid}` : null,
    fetcher
  );
  const bundleChangeSignal = useUiChangeKindSignal('bundle');
  const lastBundleChangeSignal = useRef(bundleChangeSignal);

  useEffect(() => {
    if (!matterGuid || bundleChangeSignal === lastBundleChangeSignal.current) {
      return;
    }
    lastBundleChangeSignal.current = bundleChangeSignal;
    void mutate();
  }, [bundleChangeSignal, matterGuid, mutate]);

  const deleteBundle = async (bundleId: string) => {
    await backendClient.delete(`/bundle/matter/${matterGuid}/${bundleId}`);
    mutate();
  };

  return {
    bundles: data ?? [],
    isLoading,
    isError: error,
    mutate,
    deleteBundle,
  };
};
